import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Label } from "./ErrorMessage.styles";
var ErrorMessage = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    if (!children) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Label, _object_spread_props(_object_spread({}, props), {
        role: "alert",
        "aria-live": "polite",
        children: children
    }));
};
export { ErrorMessage };
